export default "__VITE_ASSET__DnCYgYL1__"